import { useMediaPredicate } from 'react-media-hook'

const useMediaQuery = (minWidth = 900) => {
    return useMediaPredicate(`(min-width: ${minWidth}px)`)
}

export default useMediaQuery;